import React, {useContext, useEffect} from "react";
import "./Loader.css";
import AuthContext from "../../context/authContext.jsx";

const Loader = () => {
  const { isLoading } = useContext(AuthContext);
  useEffect(() => {
    if (window.SwivuAppLoaderInstance) {
      if (isLoading) {
        window.SwivuAppLoaderInstance.show();
      } else {
        window.SwivuAppLoaderInstance.hide();
      }
    }
  }, [isLoading])


  return <></>
};

export default Loader;
